<template>
  <ListItem component="button" type="button" @click="$emit('click', 'support')">
    <ListItemAction>
      <DonationIcon size="1.5rem" />
    </ListItemAction>
    <ListItemContent>
      <ListItemTitle>Support</ListItemTitle>
      <ListItemSubtitle wrap
        >Request a donation or tip from your followers.</ListItemSubtitle
      >
    </ListItemContent>
  </ListItem>
</template>

<script>
import {
  ListItem,
  ListItemAction,
  ListItemContent,
  ListItemSubtitle,
  ListItemTitle,
  DonationIcon,
} from '@campsite-bio/component-lib';

export default {
  components: {
    ListItem,
    ListItemAction,
    ListItemContent,
    ListItemSubtitle,
    ListItemTitle,
    DonationIcon,
  },
};
</script>

<style lang="scss" scoped></style>
